import { COLOR_SEARCH_PARAM } from 'product/constants/constants'
import { env } from 'utils/envManager'

import type { Color, FullProduct } from '../../types/FullProduct'

interface GetProductUrl {
	color: Color
	id: FullProduct['id']
	url: FullProduct['url']
	countryISO: string
	languageISO: string
	searchParams: Record<string, string>
}

export function getProductUrl({
	color,
	url,
	id,
	countryISO,
	languageISO,
	searchParams,
}: GetProductUrl): string {
	const productId = color.relatedProductId || id
	const baseBackupUrl = `/${countryISO.toLowerCase()}/${languageISO.toLowerCase()}/p/${productId}`
	const baseUrl =
		color.relatedProductUrl || (!color.relatedProductId && url) || baseBackupUrl

	const productUrl = new URL(baseUrl, env.NEXT_PUBLIC_SITE_BASE_URL)

	const urlSearchParams = new URLSearchParams(searchParams)
	urlSearchParams.set(COLOR_SEARCH_PARAM, color.id)
	productUrl.search = urlSearchParams.toString()

	return productUrl.pathname + productUrl.search
}
